module.exports = __webpack_public_path__ + "img/voice.890b5391.png";